/** `reporters` represents the default set of reporters configured to track actions in the client application */
const reporters = new Map();
/**
 * Add reporter to reporters Map
 */
export function setReporter(reporter) {
    reporters.set(reporter.name, reporter);
}
/**
 * Get reporters map
 */
export function getReporters() {
    return reporters;
}
//# sourceMappingURL=reporters.js.map